<template>
  <FilterLayout v-model="advance_filter">
    <AddressSection
      :province="filterState.address.province"
      :amphur="filterState.address.amphur"
      :tumbol="filterState.address.tumbol"
      :village="filterState.address.village"
      @update:province="updateAddress($event, 'province')"
      @update:amphur="updateAddress($event, 'amphur')"
      @update:tumbol="updateAddress($event, 'tumbol')"
      @update:village="updateAddress($event, 'village')"
      parentComponent="member"
      key="member"
      :disabledProvince="getAllowActionByCurrRole('disabled-province-search')"
    />
    <PersonInfoSection
      class="mt-2"
      :national_id="filterState.national_id"
      :full_name="filterState.full_name"
      @update:national_id="handelNationalIdChange"
      @update:full_name="handelFullNameChange"
    />

    <!-- advance -->
    <section data-test="filter-advance" v-show="advance_filter">
      <hr class="border-theme-33 mt-3" />

      <section data-test="filter-genaration-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          ช่วงวัย
        </h4>
        <div class="flex flex-wrap">
          <CheckboxIconButton
            class="mr-1"
            icon="PackageIcon"
            id="dex-checkbox"
            value="เด็กเล็ก"
            v-model="filterState.age_rage_selected"
            tooltip="เด็กเล็ก (0 - 6 ปี)"
          >
            <img class="h-5 w-5 " src="@/assets/images/icon/baby-boy.png" />
          </CheckboxIconButton>
          <CheckboxIconButton
            class="mr-1"
            icon="PackageIcon"
            id="dexto-checkbox"
            value="เด็ก"
            v-model="filterState.age_rage_selected"
            tooltip="เด็ก (6 ปีขึ้นไป - 12 ปี)"
          >
            <img class="h-5 w-5 " src="@/assets/images/icon/kid.png" />
          </CheckboxIconButton>
          <CheckboxIconButton
            class="mr-1"
            icon="PackageIcon"
            id="wairoon-checkbox"
            value="เด็กโต/วัยรุ่น"
            v-model="filterState.age_rage_selected"
            tooltip="เด็กโต/วัยรุ่น (12 ปีขึ้นไป - 18 ปี)"
          >
            <img class="h-5 w-5 " src="@/assets/images/icon/teenager.png" />
          </CheckboxIconButton>
          <CheckboxIconButton
            class="mr-1"
            icon="PackageIcon"
            id="phuyai-checkbox"
            value="ผู้ใหญ่/วัยแรงงาน"
            v-model="filterState.age_rage_selected"
            tooltip="ผู้ใหญ่/วัยแรงงาน (18 ปีขึ้นไป - 59 ปี)"
          >
            <img class="h-5 w-5 " src="@/assets/images/icon/man.png" />
          </CheckboxIconButton>
          <CheckboxIconButton
            icon="PackageIcon"
            id="konkea-checkbox"
            value="ผู้สูงอายุ"
            v-model="filterState.age_rage_selected"
            tooltip="ผู้สูงอายุ (60 ปีขึ้นไป)"
          >
            <img class="h-5 w-5 " src="@/assets/images/icon/old-man.png" />
          </CheckboxIconButton>
        </div>
      </section>

      <section data-test="filter-gender-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          เพศ
        </h4>
        <RadioCustomButton
          class="mt-2"
          name="gender-radio-group"
          first-option-id="male-option"
          second-option-id="female-option"
          first-option-value="ชาย"
          second-option-value="หญิง"
          v-model="filterState.gender"
        />
      </section>

      <section data-test="filter-is-household-head-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          หัวหน้าครัวเรือน
        </h4>
        <RadioCustomButton
          class="mt-2"
          name="is-household-head-radio-group"
          first-option-id="household-head-option"
          second-option-id="not-household-head-option"
          first-option-value="ใช่"
          second-option-value="ไม่ใช่"
          v-model="filterState.is_household_head"
        />
      </section>

      <section data-test="filter-is-family-head-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          หัวหน้าครอบครัว
        </h4>
        <RadioCustomButton
          class="mt-2"
          name="is-family-head-radio-group"
          first-option-id="family-head-option"
          second-option-id="not-family-head-option"
          first-option-value="ใช่"
          second-option-value="ไม่ใช่"
          v-model="filterState.is_family_head"
        />
      </section>

      <section data-test="filter-is-handicapped-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          ผู้พิการ
        </h4>
        <RadioCustomButton
          class="mt-2"
          name="is-handicapped-radio-group"
          first-option-id="handicapped-option"
          second-option-id="not-handicapped-option"
          first-option-value="ใช่"
          second-option-value="ไม่ใช่"
          v-model="filterState.is_handicapped"
        />
      </section>

      <section data-test="filter-member-problem-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          สภาพปัญหา
        </h4>
        <select
          class="form-select form-select-sm"
          v-model="filterState.problems"
          disabled
        >
          <option :value="null" disabled selected>
            กรุณาเลือกสภาพปัญหา
          </option>
        </select>
      </section>

      <section data-test="filter-benefit-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          สวัสดิการ
        </h4>
        <select
          class="form-select form-select-sm"
          v-model="filterState.benefits"
          disabled
        >
          <option value="" disabled selected>
            กรุณาเลือกสวัสดิการ
          </option>
        </select>
      </section>

      <section data-test="filter-education-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          การศึกษา
        </h4>
        <v-select
          data-test="education-select"
          id="education-select"
          v-model="filterState.educations"
          :options="educationOption"
          label="desc"
          :clearable="true"
          :multiple="true"
          placeholder="กรุณาเลือกการศึกษา"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
          </template>
        </v-select>
      </section>

      <section data-test="filter-main-ocupation-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          อาชีพหลัก
        </h4>
        <v-select
          data-test="occupation-select"
          id="occupation-select"
          v-model="filterState.primary_occupations"
          :options="primaryOccuOption"
          label="desc"
          :clearable="true"
          :multiple="true"
          placeholder="กรุณาอาชีพหลัก"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
          </template>
        </v-select>
      </section>

      <section data-test="filter-patient-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          ผู้ป่วย
        </h4>
        <div class="flex flex-wrap">
          <CheckboxCustomButton
            id="chronic-patient-checkbox"
            :value="{
              code: 'PBHE6',
              desc: 'ผู้ป่วยเรื้อรัง',
            }"
            text="ผู้ป่วยเรื้อรัง"
            class="mx-1 my-1"
            v-model="filterState.patients"
          />
          <CheckboxCustomButton
            id="bedridden-patient-checkbox"
            :value="{
              code: 'PBHE4',
              desc: 'ผู้ป่วยติดเตียง',
            }"
            text="ผู้ป่วยติดเตียง"
            class="mx-1 my-1"
            v-model="filterState.patients"
          />
          <CheckboxCustomButton
            id="serious-patient-checkbox"
            :value="{
              code: 'PBHE5',
              desc: 'ผู้ป่วยร้ายแรง',
            }"
            text="ผู้ป่วยร้ายแรง"
            class="mx-1 my-1"
            v-model="filterState.patients"
          />
        </div>
      </section>

      <section data-test="filter-age-range-section">
        <h4 class="text-base font-normal leading-none text-theme-33 mb-2">
          ช่วงอายุ
        </h4>
        <div class="flex items-baseline">
          <input
            type="number"
            name="start-age-range-input"
            id="start-age-range-input"
            class="form-control form-control-sm text-center"
            placeholder="เริ่มต้น"
            v-model="filterState.age_rage.start"
          />
          <p class="mx-1">
            -
          </p>
          <input
            type="number"
            name="end-age-range-input"
            id="end-age-range-input"
            class="form-control form-control-sm text-center"
            placeholder="สิ้นสุด"
            v-model="filterState.age_rage.end"
          />
        </div>
      </section>
      <VolunteerSection v-model="filterState.volunteer" />
      <!-- End: Advance filter -->
    </section>
    <div class="flex justify-end mt-3">
      <button class="btn btn-outline-secondary mr-2" @click="resetState">
        ล้าง
      </button>
      <button class="btn btn-primary" @click="sendToStore">
        ค้นหา
      </button>
    </div>
  </FilterLayout>
</template>

<script setup>
import AddressSection from "./component/AddressSection.vue";
import VolunteerSection from "./component/VolunteerSection.vue";
import FilterLayout from "./layout/index.vue";
import PersonInfoSection from "./component/PersonInfoSection.vue";
import CheckboxIconButton from "../base/checkbox-icon-button/index.vue";
import RadioCustomButton from "../base/radio-custom-button/index.vue";
import CheckboxCustomButton from "../base/checkbox-cutom-button/index.vue";
import { reactive, onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import { getAllowActionByCurrRole } from "@/utils/get-roles"
// START: declare data

const INIT_FILTER_VALUE = {
  national_id: null,
  full_name: null,
  address: {
    amphur: null,
    province: null,
    tumbol: null,
    village: null,
  },
  age_rage_selected: [],
  gender: null,
  is_household_head: null,
  is_family_head: null,
  is_handicapped: null,
  problems: [],
  benefits: [],
  educations: [],
  primary_occupations: [],
  patients: [],
  age_rage: {
    start: null,
    end: null,
  },
  volunteer: null,
};

const filterState = reactive(JSON.parse(JSON.stringify(INIT_FILTER_VALUE)));
const store = useStore();
const advance_filter = ref(false);
const educationOption = ref([
  {
    code: "EL1",
    desc: "ไม่ได้เรียนหนังสือ",
  },
  {
    code: "EL2",
    desc: "ประถมศึกษา",
  },
  {
    code: "EL3",
    desc: "มัธยมศึกษาตอนต้น",
  },
  {
    code: "EL4",
    desc: "มัธยมศึกษาตอนปลาย/ปวช",
  },
  {
    code: "EL5",
    desc: "ปวส./อนุปริญญา",
  },
  {
    code: "EL6",
    desc: "ปริญญาตรี",
  },
  {
    code: "EL7",
    desc: "ปริญญาโท/ปริญญาเอก",
  },
]);
const primaryOccuOption = ref([
  {
    code: "OC1",
    desc: "รับจ้างทั่วไป",
  },
  {
    code: "OC2",
    desc: "เกษตรกรรม (พืช ปศุสัตว์ ประมง)",
  },
  {
    code: "OC3",
    desc: "ลูกจ้าง/พนักงานเอกชน",
  },
  {
    code: "OC4",
    desc: "รับราชการ",
  },
  {
    code: "OC5",
    desc: "เจ้าหน้าที่ของรัฐ",
  },
  {
    code: "OC6",
    desc: "พนักงานรัฐวิสาหกิจ",
  },
  {
    code: "OC7",
    desc: "ธุรกิจส่วนตัว/ค้าขาย/เจ้าของกิจการ",
  },
  {
    code: "OC8",
    desc: "ข้าราขการบำเหน็ดบำนาญ",
  },
  {
    code: "OC9",
    desc: "อื่นๆ",
  },
]);

const filterStore = computed(() => store.getters["memberFilter/getAllFilter"]);

onMounted(async () => {
  Object.assign(filterState, JSON.parse(JSON.stringify(filterStore.value)));
  if(localStorage.getItem("volunteerData")){
    filterState.volunteer = JSON.parse(localStorage.getItem("volunteerData"))
  }
  advance_filter.value = filterState.advance_filter;
});

const handelNationalIdChange = (evt) => {
  filterState.national_id = evt;
};
const handelFullNameChange = (evt) => {
  filterState.full_name = evt;
};
const resetState = () => {
  const initFilter = JSON.parse(JSON.stringify(INIT_FILTER_VALUE));
  initFilter.address.province = filterState.address.province;
  Object.assign(filterState, initFilter);
};
const sendToStore = () => {
  let result = filterState;
  result.advance_filter = advance_filter.value;
  if(localStorage.getItem("volunteerData")){
    result.volunteer = JSON.parse(localStorage.getItem("volunteerData"))
  }
  store.dispatch("memberFilter/setStore", JSON.parse(JSON.stringify(result)));
};
const updateAddress = (evt, key) => {
  filterState.address[key] = evt;
};
</script>

<style lang="scss" scoped>
section {
  margin-top: 0.75rem;
}
</style>
